// src/components/ProtectedRoute.js
import { getToken } from "../services/auth";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ children, roles }) {
  const token = getToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (roles?.length) {
    try {
      const decoded = jwtDecode(token);
      if (!roles.includes(decoded?.role)) {
        return <Navigate to="/home" replace />;
      }
    } catch {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
}